// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7d5a6aab","455":"394229b4","977":"e0b750be"}[chunkId] + ".chunk.js";
};